<div *ngIf="selectedBusinessUnit &&  !shouldRefreshContents" class="box-dash">

  <tabset appDisableRightClick>
    <tab #tabOnboardingRequest="tab"
         customClass="btn btn-default"
         style="padding:0;"
         active="true"
         heading="REQUESTS">
      <div class="tpm-box-dash-hdr-bar" style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">Onboarding Dashboard</h2>
      </div>
    </tab>
    <tab #tabOnboardingHistory="tab"
         customClass="btn btn-default"
         style="padding:0;"
         heading="HISTORY">
      <div class="tpm-box-dash-hdr-bar" style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">Onboarding Dashboard</h2>
      </div>
    </tab>

  </tabset>

  <onboardingrequestlayout *ngIf="tabOnboardingRequest.active"></onboardingrequestlayout>

  <onboardinghistorylayout *ngIf="tabOnboardingHistory.active"></onboardinghistorylayout>

</div>
